import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export const useAstroEvents = () => {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const controller = new AbortController();
    api('/events', { signal: controller.signal }).then(setEvents).catch(e => { if (e.name !== 'AbortError') setError(e.message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, []);
  return { events, error, loading };
};